import * as React from "react"
import BaseController from "../base-controller"
import Features from "../components/base/Features"

// markup
class Test extends React.Component {
  render() {
    return (
      <BaseController>


        <section class="text-center">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-8 col-lg-6">
                            <div class="cta">
                                <h2>Choose Your Plan</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        <section class=" bg--dark">
          <div class="container">
              <div class="row">
                  <div class="col-md-3">
                      <div class="pricing pricing-1 boxed boxed--sm boxed--border">
                          <h3>Free</h3>
                          <span class="h2">
                              <strong>$0</strong>
                          </span>
                          <span class="type--fine-print">No credit cart required</span>
                          <hr />
                          <ul>
                              <li>
                                  <span class="checkmark bg--primary-1"></span>
                                  <span>5000 Pageviews / Month</span>
                              </li>
                              <li>
                                  <span class="checkmark bg--primary-1"></span>
                                  <span>1 Web site</span>
                              </li>
                              <li>
                                  <span class="checkmark bg--primary-1"></span>
                                  <span>Unlimited Popups</span>
                              </li>
                              <li>
                                <span class="checkmark bg--primary-1"></span>
                                <span>Online Support</span>
                              </li>
                          </ul>
                          <a id="pricing--get-started--layout-Plan-link" class="btn btn--primary" href="https://dashboard.popupfox.com/register">
                              <span class="btn__text">
                                  Get Started
                              </span>
                          </a>
                      </div>
                  </div>
                  <div class="col-md-3">
                      <div class="pricing pricing-1 boxed boxed--sm boxed--border boxed--emphasis">
                          <h3>Basic</h3>
                          <span class="h2">
                              <strong>$23</strong>
                          </span>
                          <span class="type--fine-print">Per Month (billed annually)</span>
                          <span class="label">Popuplar</span>
                          <hr />
                          <ul>
                              <li>
                                  <span class="checkmark bg--primary-1"></span>
                                  <span>100.000 Pageviews / Month</span>
                              </li>
                              <li>
                                  <span class="checkmark bg--primary-1"></span>
                                  <span>Unlimited Web site</span>
                              </li>
                              <li>
                                  <span class="checkmark bg--primary-1"></span>
                                  <span>Unlimited Popups</span>
                              </li>
                              <li>
                                <span class="checkmark bg--primary-1"></span>
                                <span>Online Support</span>
                              </li>
                              <li>
                                <span className="checkmark bg--primary-1"></span>
                                <span>100% Moneyback Guarantee</span>
                              </li>
                          </ul>
                          <a id="pricing--try-for-free--layout-plan-baisc-link" class="btn btn--primary" href="https://dashboard.popupfox.com/register">
                              <span class="btn__text">
                                  Try For Free
                              </span>
                          </a>
                      </div>
                  </div>
                  <div class="col-md-3">
                      <div class="pricing pricing-1 boxed boxed--sm boxed--border">
                          <h3>Professional</h3>
                          <span class="h2">
                              <strong>$59</strong>
                          </span>
                          <span class="type--fine-print">Per Month (billed annually)</span>
                          <hr />
                          <ul>
                              <li>
                                  <span class="checkmark bg--primary-1"></span>
                                  <span>500.000 Pageviews / Month</span>
                              </li>
                              <li>
                                  <span class="checkmark bg--primary-1"></span>
                                  <span>Unlimited Web site</span>
                              </li>
                              <li>
                                  <span class="checkmark bg--primary-1"></span>
                                  <span>Unlimited Popups</span>
                              </li>
                              <li>
                                <span class="checkmark bg--primary-1"></span>
                                <span>Online Support</span>
                              </li>
                              <li>
                                <span className="checkmark bg--primary-1"></span>
                                <span>100% Moneyback Guarantee</span>
                              </li>
                          </ul>
                          <a id="pricing--try-for-free--layout-plan-professional-link" class="btn btn--primary" href="https://dashboard.popupfox.com/register">
                              <span class="btn__text">
                                  Try For Free
                              </span>
                          </a>
                      </div>
                  </div>
                  <div class="col-md-3">
                      <div class="pricing pricing-1 boxed boxed--sm boxed--border">
                          <h3>Expert</h3>
                          <span class="h2">
                              <strong>$95</strong>
                          </span>
                          <span class="type--fine-print">Per Month (billed annually)</span>
                          <hr />
                          <ul>
                              <li>
                                  <span class="checkmark bg--primary-1"></span>
                                  <span>1 Million Pageviews / Month</span>
                              </li>
                              <li>
                                  <span class="checkmark bg--primary-1"></span>
                                  <span>Unlimited Web site</span>
                              </li>
                              <li>
                                  <span class="checkmark bg--primary-1"></span>
                                  <span>Unlimited Popups</span>
                              </li>
                              <li>
                                <span class="checkmark bg--primary-1"></span>
                                <span>Online Support</span>
                              </li>
                              <li>
                                <span className="checkmark bg--primary-1"></span>
                                <span>100% Moneyback Guarantee</span>
                              </li>
                          </ul>
                          <a id="pricing--try-for-free--layout-plan-expert-link" class="btn btn--primary" href="https://dashboard.popupfox.com/register">
                              <span class="btn__text">
                                  Try For Free
                              </span>
                          </a>
                      </div>
                  </div>
              </div>
          </div>
        </section>

        <section class="text-center">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-8 col-lg-6">
                            <div class="cta">
                                <h2>Explore Detailed Features</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        


        <Features/>


      </BaseController>
    )
  }
}

export default Test
